import React from 'react'

import * as h2Api from '../h2Api'

export const CONTENT_WIZARD_GET_TYPES = 'CONTENT_WIZARD_GET_TYPES'
export const CONTENT_WIZARD_OPEN_CLOSE = 'CONTENT_WIZARD_OPEN_CLOSE'
export const CONTENT_WIZARD_SELECT_CONTENT_TYPE = 'CONTENT_WIZARD_SELECT_CONTENT_TYPE'
export const CONTENT_WIZARD_NEXT = 'CONTENT_WIZARD_NEXT'
export const CONTENT_WIZARD_PREVIOUS = 'CONTENT_WIZARD_PREVIOUS'
export const CONTENT_WIZARD_FIELD_CHANGE = 'CONTENT_WIZARD_FIELD_CHANGE'
export const CONTENT_WIZARD_SUBMIT = 'CONTENT_WIZARD_SUBMIT'
export const CONTENT_WIZARD_SUGGEST = 'CONTENT_WIZARD_SUGGEST'
export const CONTENT_WIZARD_ADD_OR_REMOVE_CONTENT_LISTING_OBJECT =
  'CONTENT_WIZARD_ADD_OR_REMOVE_CONTENT_LISTING_OBJECT'
export const CONTENT_WIZARD_LIST_FILES = 'CONTENT_WIZARD_LIST_FILES'
export const CONTENT_WIZARD_ADD_FILE = 'CONTENT_WIZARD_ADD_FILE'
export const CONTENT_WIZARD_FILE_UPLOAD = 'CONTENT_WIZARD_FILE_UPLOAD'
export const CONTENT_WIZARD_LIST_RESUMES = 'CONTENT_WIZARD_LIST_RESUMES'
export const CONTENT_WIZARD_LIST_RESUME_CONTENT = 'CONTENT_WIZARD_LIST_RESUME_CONTENT'
export const CONTENT_WIZARD_SELECT_FILE = 'CONTENT_WIZARD_SELECT_FILE'
export const CONTENT_WIZARD_SELECT_SURVEY = 'CONTENT_WIZARD_SELECT_SURVEY'
export const CONTENT_WIZARD_LOAD_SURVEYS = 'CONTENT_WIZARD_LOAD_SURVEYS'
export const FORM_SUBMIT_START = 'CONTENT_WIZARD_FORM_SUBMIT_START'
export const CONTENT_WIZARD_ADD_FILE_TO_SLIDESHOW = 'CONTENT_WIZARD_ADD_FILE_TO_SLIDESHOW'
export const CONTENT_WIZARD_REMOVE_FILE_FROM_SLIDESHOW =
  'CONTENT_WIZARD_REMOVE_FILE_FROM_SLIDESHOW'

export const CONTENT_TEXT = {
  idx: 1,
  cssClass: 'fal fa-file-alt',
  choiceLabel: 'Simple Text',
  description:
    'A basic text block that allows you to add simple, textual content to the profile.'
}

export const CONTENT_ADDRESS = {
  idx: 8,
  cssClass: 'fal fa-map-marker',
  choiceLabel: 'Address and Map',
  description:
    'Add a location to the profile and have it displayed in text as well as on a map'
}

export const CONTENT_YOUTUBE = {
  idx: 11,
  cssClass: 'fab fa-youtube',
  choiceLabel: 'Youtube Video',
  description: 'Embed a Youtube video section in the profile'
}

export const CONTENT_TWITTER = {
  idx: 10,
  cssClass: 'fab fa-twitter',
  choiceLabel: 'Twitter Feed',
  description:
    'Embed a Twitter feed in the profile so viewers can always see the latest tweets from the organization'
}

export const CONTENT_SCHEDULE = {
  idx: 2,
  cssClass: 'fal fa-calendar',
  choiceLabel: 'Event',
  description:
    'Add a calendar event to inform people about upcoming dates and allow for RSVP and/or Applications'
}

export const CONTENT_SURVEY = {
  idx: 14,
  cssClass: 'fal fa-list-ul',
  choiceLabel: 'Survey',
  description: 'Add a section which allows the user to complete a survey'
}

export const CONTENT_PHOTO = {
  idx: 0,
  cssClass: 'fal fa-file-image',
  choiceLabel: 'Slideshow',
  description: 'Add a section which presents one or more pictures in a slideshow'
}

export const CONTENT_LISTING_OCCUPATIONS = {
  idx: 3,
  cssClass: 'fal fa-briefcase',
  choiceLabel: 'Occupations',
  description:
    'Add a section which contains a listing with links to occupations in the system'
}

export const CONTENT_LISTING_ADDITIONAL_RESOURCES = {
  idx: 13,
  cssClass: 'fal fa-external-link',
  choiceLabel: 'External Links',
  description:
    'Add a section which contains a list of links to other sites or external resources'
}

export const CONTENT_LISTING_COLLEGE = {
  idx: 4,
  cssClass: 'fal fa-university',
  choiceLabel: 'Colleges',
  description:
    'Add a section which contains a listing with links to educational institutions in the system'
}

export const CONTENT_LISTING_TRAINING = {
  idx: 5,
  cssClass: 'fal fa-graduation-cap',
  choiceLabel: 'Instructional Programs',
  description:
    'Add a section which contains a listing with links to instructional programs in the system'
}

export const CONTENT_LISTING_JOB_OPENING = {
  idx: 7,
  cssClass: 'fal fa-handshake',
  choiceLabel: 'Indeed Job Openings',
  description: 'Add a section which contains a listing of job openings for the profile'
}

export const CONTENT_LISTING_DIRECT_EMPLOYER_JOB_OPENING = {
  idx: 28,
  cssClass: 'fal fa-handshake',
  choiceLabel: 'Job Openings',
  description: 'Add a section which contains a listing of job openings for the profile'
}

export const CONTENT_LISTING_CERTIFICATION = {
  idx: 6,
  cssClass: 'fal fa-certificate',
  choiceLabel: 'Certifications',
  description:
    'Add a section which contains a listing with links to certifications in the system'
}

export const CONTENT_LISTING_INDUSTRIES = {
  idx: 16,
  cssClass: 'fal fa-industry',
  choiceLabel: 'Industries',
  description:
    'Add a section which contains a listing with links to industry profiles in the system'
}

export const CONTENT_LISTING_OTHER_PROFILES = {
  idx: 12,
  cssClass: 'fal fa-link',
  choiceLabel: 'Other Profiles',
  description:
    'Add links to other profiles in the system, like companies, institutions, certifications, and programs'
}

export const CONTENT_LISTING_FILES = {
  idx: 21,
  cssClass: 'fal fa-file-upload',
  choiceLabel: 'File Listing',
  description:
    'Add a section which contains a listing of files that can be downloaded by a user'
}

export const CONTENT_INTEREST_PROFILER = {
  idx: 17,
  choiceLabel: 'Interest Profiler Results'
}

export const CONTENT_WORK_IMPORTANCE_PROFILER = {
  idx: 18,
  choiceLabel: 'Work Importance Profiler Results'
}

export const CONTENT_SKILLS_PROFILER = {
  idx: 19,
  choiceLabel: 'Skills Profiler Results'
}

export const CONTENT_WORK_KEYS = {
  idx: 20,
  choiceLabel: 'Work Keys Scores'
}

export const CONTENT_SUMMARY_QUALIFICATIONS = {
  idx: 22,
  choiceLabel: 'Summary of Qualifications'
}

export const CONTENT_PROMOTE_FILES = {
  idx: 24,
  cssClass: 'fal fa-file',
  choiceLabel: 'Promoted Document',
  description:
    'Add a section which contains a single document to be displayed to the user for downloading'
}

export const CONTENT_EMPLOY_GOALS = {
  idx: 25,
  choiceLabel: "I'm looking to"
}

export const CONTENT_EMPLOY_CRITERIA = {
  idx: 26,
  choiceLabel: 'I need opportunities that'
}

export const CONTENT_CAREER_CLUSTER = {
  idx: 27,
  cssClass: 'fal fa-chart-pie',
  label: 'Career Clusters',
  choiceLabel: 'Career Clusters',
  description:
    'Add a section which contains a listing with links to career clusters found in the system'
}

export const CONTENT_CONTACT_INFO = {
  idx: 29,
  cssClass: 'fal fa-address-card',
  label: 'Contact Info',
  choiceLabel: 'Contact Info',
  description: 'Add a section that contains contact info for people at the location'
}

export const CONTENT_PROFILE_TAGS = {
  idx: 30,
  cssClass: 'fal fa-tag',
  label: 'Search Criteria',
  choiceLabel: 'Search Criteria',
  description: 'Add a section that outputs the search criteria tags for the given profile'
}

export const CONTENT_LISTING = {
  idx: 3,
  choiceLabel: 'Content Listing',
  listingTypes: [
    /*
     * determines the value of "listingtype" field that goes in the PUT call
     * values taken from : src/main/scala/h2/common/profiles/ProfileSection.scala
     */
    CONTENT_LISTING_OCCUPATIONS,
    CONTENT_LISTING_COLLEGE,
    CONTENT_LISTING_JOB_OPENING,
    CONTENT_LISTING_DIRECT_EMPLOYER_JOB_OPENING,
    CONTENT_CAREER_CLUSTER,
    CONTENT_LISTING_INDUSTRIES,
    CONTENT_LISTING_OTHER_PROFILES
  ]
}

export const ALL_CONTENT_TYPES = [
  CONTENT_TEXT,
  CONTENT_ADDRESS,
  CONTENT_YOUTUBE,
  CONTENT_SCHEDULE,
  CONTENT_SURVEY,
  CONTENT_PHOTO,
  CONTENT_INTEREST_PROFILER,
  CONTENT_WORK_IMPORTANCE_PROFILER,
  CONTENT_SKILLS_PROFILER,
  CONTENT_WORK_KEYS,
  CONTENT_LISTING_FILES,
  CONTENT_SUMMARY_QUALIFICATIONS,
  CONTENT_PROMOTE_FILES,
  CONTENT_EMPLOY_GOALS,
  CONTENT_EMPLOY_CRITERIA,
  CONTENT_LISTING_OCCUPATIONS,
  CONTENT_PROFILE_TAGS,
  CONTENT_LISTING_COLLEGE,
  dynamicValues.newSiteLook
    ? CONTENT_LISTING_DIRECT_EMPLOYER_JOB_OPENING
    : CONTENT_LISTING_JOB_OPENING,
  CONTENT_CAREER_CLUSTER,
  CONTENT_LISTING_INDUSTRIES,
  CONTENT_LISTING_OTHER_PROFILES
]

export const uploadFile = (input, profileId, profileType) => dispatch => {
  const data = new FormData()

  data.append('file', input.files[0])

  return h2Api.postFile(
    `/profiles/${profileType}/${profileId}/upload`,
    data
  )({
    type: CONTENT_WIZARD_FILE_UPLOAD
  })(dispatch)
}

export const fetchUpcomingEvents = () =>
  h2Api.get('/user/calendar/upcoming')({ type: FETCH_UPCOMING_EVENTS })

// -------------------- Action Creators

export const openContentWizard = (profileId, profileType) => dispatch => {
  console.log(profileId)

  return h2Api
    .get(`/profiles/${profileType}/sections`)({ type: CONTENT_WIZARD_GET_TYPES })(
      dispatch
    )
    .then(function () {
      Promise.resolve(
        dispatch({
          type: CONTENT_WIZARD_OPEN_CLOSE,
          isOpened: true,
          profileId,
          profileType
        })
      )
    })
}

export const closeContentWizard = () => dispatch =>
  dispatch({ type: CONTENT_WIZARD_OPEN_CLOSE, isOpened: false })

export const selectContentType = idx => dispatch => {
  dispatch({ type: CONTENT_WIZARD_SELECT_CONTENT_TYPE, idx })

  if (idx === CONTENT_SUMMARY_QUALIFICATIONS.idx) {
    // load the available files
    dispatch(listResumes())
  } else if (
    idx === CONTENT_LISTING_FILES.idx ||
    idx === CONTENT_PROMOTE_FILES.idx ||
    idx === CONTENT_PHOTO.idx
  ) {
    dispatch(listFiles())
  } else if (idx === CONTENT_SURVEY.idx) {
    dispatch(listSurveys())
  }

  return Promise.resolve(true)
}

const guessType = original => {
  switch (original) {
    case CONTENT_LISTING_OCCUPATIONS.idx:
    case CONTENT_LISTING_COLLEGE.idx:
    case CONTENT_LISTING_JOB_OPENING.idx:
    case CONTENT_LISTING_DIRECT_EMPLOYER_JOB_OPENING:
    case CONTENT_LISTING_ADDITIONAL_RESOURCES.idx:
    case CONTENT_LISTING_INDUSTRIES.idx:
    case CONTENT_CAREER_CLUSTER.idx:
    case CONTENT_LISTING_OTHER_PROFILES.idx:
      return CONTENT_LISTING.idx
    default:
      return original
  }
}

export const setForEdit = section => dispatch => {
  return dispatch(selectContentType(section.type))
    .then(() => {
      dispatch(onFieldChange('idForEdit', true, section.id))
      dispatch(onFieldChange('title', true, section.title))
      dispatch(onFieldChange('body', true, section.body))
      dispatch(onFieldChange('footer', true, section.footer))
      dispatch(onFieldChange('floatBodyLeft', true, section.floatBodyLeft))
      dispatch(onFieldChange('floatFooterRight', true, section.floatFooterRight))
      dispatch(onFieldChange('sectionCssClass', true, section.sectionCssClass))
      dispatch(onFieldChange('sectionTemplateId', true, section.sectionTemplateId))
      dispatch(onFieldChange('suppressTitle', true, section.suppressTitle))
    })
    .then(() => {
      switch (section.type) {
        case CONTENT_ADDRESS.idx:
          if (section.additional && section.additional.components) {
            dispatch(
              onFieldChange('laddress', false, section.additional.components.address)
            )
            dispatch(onFieldChange('lcity', false, section.additional.components.city))
            dispatch(onFieldChange('lstate', false, section.additional.components.state))
            dispatch(onFieldChange('lzip', false, section.additional.components.zipCode))
          }

          break
        case CONTENT_YOUTUBE.idx:
          dispatch(onFieldChange('videoId', false, section.videoId))
          break
        case CONTENT_TWITTER.idx:
          dispatch(onFieldChange('twitterName', false, section.screenName))
          break
        case CONTENT_CONTACT_INFO.idx: {
          const attrs = [
            'firstName',
            'lastName',
            'email',
            'phone',
            'position',
            'address',
            'city',
            'state',
            'zip',
            'notes'
          ]

          attrs.forEach(i => dispatch(onFieldChange(i, false, section[i])))
          break
        }
        case CONTENT_LISTING_OCCUPATIONS.idx:
        case CONTENT_LISTING_COLLEGE.idx:
        case CONTENT_LISTING_ADDITIONAL_RESOURCES.idx:
        case CONTENT_LISTING_INDUSTRIES.idx:
        case CONTENT_CAREER_CLUSTER.idx:
        case CONTENT_LISTING_OTHER_PROFILES.idx:
          dispatch(onFieldChange('listingtype', false, section.type))
          dispatch(
            onFieldChange(
              'values',
              false,
              (section.additional || []).map(s => {
                return {
                  label: s.title,
                  type: `${section.type}`,
                  value: s.id
                }
              })
            )
          )
          break
        case CONTENT_LISTING_JOB_OPENING.idx:
          dispatch(onFieldChange('listingtype', false, section.type))
          dispatch(onFieldChange('values', false, section.additional))
          break
        case CONTENT_LISTING_DIRECT_EMPLOYER_JOB_OPENING.idx:
          console.log(section)

          if (section.configuration) {
            dispatch(onFieldChange('searchTerm', false, section.configuration.searchTerm))
            dispatch(
              onFieldChange('companyName', false, section.configuration.companyName)
            )
            dispatch(onFieldChange('ein', false, section.configuration.ein))
            dispatch(onFieldChange('defaultZip', false, section.configuration.defaultZip))
            dispatch(
              onFieldChange(
                'defaultZipRadius',
                false,
                section.configuration.defaultZipRadius
              )
            )
            dispatch(
              onFieldChange('defaultState', false, section.configuration.defaultState)
            )
            dispatch(
              onFieldChange(
                'autoExpandSearch',
                false,
                section.configuration.autoExpandSearch
              )
            )
          }

          dispatch(onFieldChange('listingtype', false, section.type))
          dispatch(onFieldChange('values', false, section.additional))
          break
        case CONTENT_SCHEDULE.idx:
          break
        case CONTENT_SURVEY.idx:
          dispatch(onFieldChange('buttonText', false, section.buttonText))
          dispatch(onFieldChange('fragmentId', false, section.fragmentId))
          dispatch(onFieldChange('surveyId', false, section.surveyId))
          break
        case CONTENT_PHOTO.idx:
        case CONTENT_LISTING_FILES.idx:
          dispatch(onFieldChange('files', false, section.additional))
          break

        case CONTENT_INTEREST_PROFILER.idx:
        case CONTENT_WORK_IMPORTANCE_PROFILER.idx:
        case CONTENT_SKILLS_PROFILER.idx:
        case CONTENT_WORK_KEYS.idx:
        case CONTENT_SUMMARY_QUALIFICATIONS.idx:
          break
        case CONTENT_PROMOTE_FILES.idx:
          dispatch(onFieldChange('fileId', false, section.file))
          dispatch(onFieldChange('showButton', false, section.includeButton))
          dispatch(onFieldChange('buttonText', false, section.buttonText))
          dispatch(onFieldChange('showThumbnail', false, section.includeThumbnail))
          break

        case CONTENT_EMPLOY_GOALS.idx:
        case CONTENT_EMPLOY_CRITERIA.idx:
          dispatch(
            onFieldChange(
              'selections',
              false,
              section.additional
                .filter(s => s.selected)
                .map(s => {
                  return {
                    id: s.id,
                    name: s.value
                  }
                })
            )
          )
          break
      }
    })
    .then(() => dispatch(nextStep()))
}

export const nextStep = () => dispatch =>
  Promise.resolve(dispatch({ type: CONTENT_WIZARD_NEXT }))

export const previousStep = () => dispatch => dispatch({ type: CONTENT_WIZARD_PREVIOUS })

export const onFieldChange = (storeKeyId, isRoot, value) => dispatch => {
  dispatch({ type: CONTENT_WIZARD_FIELD_CHANGE, storeKeyId, isRoot, value })

  if (storeKeyId === 'listingtype' && value === CONTENT_SURVEY.idx) {
    // load the available files
    dispatch(listSurveys())
  }

  if (storeKeyId === 'selectedResume') {
    // load the available files
    dispatch(listResumeItems(value.id))
  }

  return Promise.resolve(true)
}

export const fetchSuggestions = (text, suggestionType) =>
  h2Api.get(`/search/suggest/${suggestionType}/${encodeURIComponent(text)}`)({
    type: CONTENT_WIZARD_SUGGEST,
    suggestionType
  })

export const addOrRemoveContentListingObject =
  (choiceObject, choiceObjectType, isAdd) => (dispatch, getState) => {
    console.log('STA', getState(), choiceObject, choiceObjectType, isAdd)
    const d = dispatch({
      type: CONTENT_WIZARD_ADD_OR_REMOVE_CONTENT_LISTING_OBJECT,
      choiceObject,
      isAdd,
      choiceObjectType
    })

    console.log(getState())

    return d
  }

export const addFile = file => dispatch =>
  dispatch({ type: CONTENT_WIZARD_ADD_FILE, file })

export const addFileToSlideshow = file => dispatch =>
  dispatch({ type: CONTENT_WIZARD_ADD_FILE_TO_SLIDESHOW, file })

export const removeFileFromSlideshow = file => dispatch =>
  dispatch({ type: CONTENT_WIZARD_REMOVE_FILE_FROM_SLIDESHOW, file })

export const selectFile = file => dispatch =>
  dispatch({ type: CONTENT_WIZARD_SELECT_FILE, file })

export const selectSurvey = survey => dispatch => {
  console.log(survey)

  return dispatch({ type: CONTENT_WIZARD_SELECT_SURVEY, survey })
}

export const listSurveys = () => (dispatch, getState) => {
  const state = getState().contentSnippetWizard
  const profileId = state.profileId
  const profileType = state.profileType
  const url = `/profiles/${profileType}/${profileId}/surveys`

  return dispatch(
    h2Api.get(url)({
      type: CONTENT_WIZARD_LOAD_SURVEYS
    })
  )
}

export const listFiles = () => (dispatch, getState) => {
  const state = getState().contentSnippetWizard
  const profileId = state.profileId

  /*
   * For testing :
   * profileId = 1
   */

  h2Api.get(`/profiles/company/${profileId}/files`)({
    type: CONTENT_WIZARD_LIST_FILES
  })(dispatch)
}

export const listResumes = () => (dispatch, getState) => {
  h2Api.get('/user/resume')({ type: CONTENT_WIZARD_LIST_RESUMES })(dispatch)
}

export const listResumeItems = id => (dispatch, getState) => {
  h2Api.get(`/user/resume/${id}`)({ type: CONTENT_WIZARD_LIST_RESUME_CONTENT })(dispatch)
}

export const startFormLoading = () => dispatch => {
  dispatch({ type: FORM_SUBMIT_START })
}

export const submit = () => (dispatch, getState) => {
  const state = getState()
  const arg = {
    stitle: state.contentSnippetWizard.title,
    scontent: state.contentSnippetWizard.body,
    stype: state.contentSnippetWizard.selectedContentTypeIndex,
    sfooter: state.contentSnippetWizard.footer,
    floatBodyLeft: state.contentSnippetWizard.floatBodyLeft,
    floatFooterRight: state.contentSnippetWizard.floatFooterRight,
    sectionTemplateId: state.contentSnippetWizard.sectionTemplateId,
    sectionCssClass: state.contentSnippetWizard.sectionCssClass,
    suppressTitle: state.contentSnippetWizard.suppressTitle,
    ...state.contentSnippetWizard[state.contentSnippetWizard.selectedContentTypeIndex]
  }
  const augment = m => {
    console.log(m)

    switch (m.stype) {
      case CONTENT_LISTING.idx:
        return {
          ...m
        }
      case CONTENT_LISTING_FILES.idx:
        return {
          ...m,
          files: m.files.map(f => (f.hasOwnProperty('fileId') ? f.fileId : f.id))
        }
      case CONTENT_PHOTO.idx:
        return {
          ...m,
          files: m.files.map(f => (f.hasOwnProperty('fileId') ? f.fileId : f.id))
        }
      case CONTENT_SURVEY.idx:
        console.log(m)

        return {
          ...m,
          surveyId: m.surveyId?.id ?? m.surveyId
        }
      default:
        return m
    }
  }
  const idForEdit = state.contentSnippetWizard.idForEdit

  if (idForEdit && idForEdit > 0) {
    return dispatch(
      h2Api.put(
        `/profiles/company/${state.contentSnippetWizard.profileId}/section/${idForEdit}`,
        augment(arg)
      )({ type: CONTENT_WIZARD_SUBMIT, existingId: idForEdit })
    )
  }

  return dispatch(
    h2Api.post(
      `/profiles/company/${state.contentSnippetWizard.profileId}/section`,
      augment(arg)
    )({ type: CONTENT_WIZARD_SUBMIT })
  )
}
